import {
  CREACTE_APPLICATION,
  GET_ALL_APPLICATION,
  GET_APPLICATION_DATA,
  DELETE_APPLICATION,
  ERROR,
  UPDATE_STATUE,
  GET_COMMENTS,
  SUBMIT_DOC,
  CREACTE_CONSULTANT_APPLICATION,
} from "../type";

const inital = {
  createApp: [],
  createConsultantApp: [],
  deleteApp: [],
  GetallApp: [],
  GetdataApp: [],
  Getcoments: [],
  UpdateStatus: [],
  Submitdoc: [],
  loading: true,
  error: [],
};
const ApplicationReduser = (state = inital, action) => {
  switch (action.type) {
    case CREACTE_APPLICATION:
      return {
        GetallApp: state.GetallApp,
        createApp: action.payload,
        loading: false,
      };
    case CREACTE_CONSULTANT_APPLICATION:
      return {
        GetdataApp: state.GetdataApp,
        createConsultantApp: action.payload,
        loading: false,
      };
    case SUBMIT_DOC:
      return {
        GetdataApp: state.GetdataApp,
        Submitdoc: action.payload,
        loading: false,
      };
    case GET_ALL_APPLICATION:
      return {
        ...state,
        GetallApp: action.payload,
        loading: false,
      };
    case DELETE_APPLICATION:
      return {
        GetallApp: state.GetallApp,
        deleteApp: action.payload,
        loading: false,
      };
    case GET_APPLICATION_DATA:
      return {
        ...state,
        GetdataApp: action.payload,
        loading: false,
      };
    case UPDATE_STATUE:
      return {
        GetdataApp: state.GetdataApp,
        UpdateStatus: action.payload, 
        loading: false,
      };
    case GET_COMMENTS:
      return {
        ...state,
        Getcoments: action.payload, 
        loading: false,
      };
    case ERROR:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
export default ApplicationReduser;
